/**
 * Uploaded files (signatures, …) are signed Azure Blob URLs. An `<img>` shows them, but the
 * storage account sends no CORS headers, so their bytes cannot be read into a PDF. The same
 * path is proxied through our own origin — `vercel.json` rewrite in production, the Vite dev
 * proxy locally — which needs no CORS. The SAS query string still authorizes each request.
 */
export const STORAGE_HOST = 'elvacore.blob.core.windows.net';
export const STORAGE_PROXY_PREFIX = '/azure-blob';

/** Same-origin URL for a storage URL, or `null` for anything else. */
export function toStorageProxyUrl(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' || parsed.hostname !== STORAGE_HOST) return null;
  return `${STORAGE_PROXY_PREFIX}${parsed.pathname}${parsed.search}`;
}
